import { alertColor } from "../constants/colors";
import styled from "styled-components/macro";

const AlertIconStyles = styled.svg`
  .alert-icon-circle {
    fill: ${alertColor};
    stroke: none;
  }

  .alert-icon-text {
    font-size: 1.9em;
    text-align: center;
    fill: #fff;
    stroke: none;
    font-weight: 700;
  }
`;

const AlertIcon = () => (
  <AlertIconStyles xmlns="http://www.w3.org/2000/svg" viewBox="0 0 33.7 42.82">
    <g>
      <circle
        style={{
          fill: alertColor,
          stroke: "none",
        }}
        cx="16.85"
        cy="17.33"
        r="16.85"
      />
      <text
        transform="translate(11.94 27.42)"
        style={{
          fontSize: "1.9em",
          textAlign: "center",
          fill: "#fff",
          stroke: "none",
          fontWeight: 700,
        }}
      >
        !
      </text>
    </g>
  </AlertIconStyles>
);

export default AlertIcon;
